import { render, staticRenderFns } from "./schoolEdit.vue?vue&type=template&id=6610e252"
import script from "./schoolEdit.vue?vue&type=script&lang=js"
export * from "./schoolEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6610e252')) {
      api.createRecord('6610e252', component.options)
    } else {
      api.reload('6610e252', component.options)
    }
    module.hot.accept("./schoolEdit.vue?vue&type=template&id=6610e252", function () {
      api.rerender('6610e252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/schoolEdit.vue"
export default component.exports